/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */



Greenmile.IPRangeProfile = Greenmile.IPRangeProfile || {};

Greenmile.IPRangeProfile.IPRangeListFields = (function () {
    function IPRangeListFields () {

        Monet.UI.Fields.Base.apply(this, arguments);
        this.createBaseStructure();

        var baseElement = { ipRanges: [] };
        var id = 0;
        var data = [];

        this.getValue = function () {
            var ipRangeToServer = [];
            var range = {};
            for (var i = 0; i < baseElement.ipRanges.length; i++) {
                range = baseElement.ipRanges[i].getValue();
                ipRangeToServer.push({ "ipv4start": range.ini, "ipv4end": range.fin });
            }
            return ipRangeToServer;
        };

        this.setValue = function (values) {
            baseElement.ipRanges = values;
        };

        this.setData = function (values) {
            if (values) {
                data = values;
            }
        };

        this.addRange = function (range) {
            baseElement.ipRanges.push(range);
        };

        this.removeItem = function (rangeId) {
            for (var i = 0; i < baseElement.ipRanges.length; i++) {
                if (baseElement.ipRanges[i].rootEl.id === rangeId) {
                    baseElement.ipRanges.splice(i);
                    return;
                }
            }
        };

        this.createElement = function () {
            var containerImages = document.createElement("div"),
                rangeIP         = new Monet.UI.Fields.Range(),
                symbolPlus      = document.createElement("div"),
                symbolNegative  = document.createElement("div"),
                divParent       = document.createElement("div");

            symbolPlus.setAttribute("class", "buttonAdd");
            symbolNegative.setAttribute("class", "buttonRemove");
            divParent.setAttribute("class", "span_container_ip");

            rangeIP.maxSize = 45;

            rangeIP.render();

            rangeIP.setLabelRange(Monet.I18n.getResourcesByKey("ipRangeProfile.range"));
            rangeIP.inputIni.setAttribute("class", "textField textIPRange mandatory ipv4Start");
            rangeIP.inputFin.setAttribute("class", "textField textIPRange mandatory ipv4End");

            rangeIP.inputIni.setAttribute("name", "ipv4Start");
            rangeIP.inputFin.setAttribute("name", "ipv4End");
            rangeIP.rootEl.setAttribute('id', 'range' + this.getNextId());

            symbolPlus.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.plus"));
            symbolNegative.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.remove"));

            containerImages.appendChild(symbolNegative);
            containerImages.appendChild(symbolPlus);

            divParent.appendChild(rangeIP.rootEl);
            divParent.appendChild(containerImages);

            this.rootEl.appendChild(divParent);

            this.addRange(rangeIP);

        };

        this.getNextId = function () {
            return id++;
        };

        this.renderElements = function () {


            for (var i = 0; i < data.length; i++) {

                var containerImages = document.createElement("div"),
                    symbolPlus      = document.createElement("div"),
                    symbolNegative  = document.createElement("div"),
                    divParent       = document.createElement("div"),
                    rangeIP         = new Monet.UI.Fields.Range(),
                    ipRangeValue    = {};

                symbolPlus.setAttribute("class", "buttonAdd");
                symbolNegative.setAttribute("class", "buttonRemove");
                divParent.setAttribute("class", "span_container_ip");

                rangeIP.maxSize = 45;

                rangeIP.render();

                rangeIP.setLabelRange(Monet.I18n.getResourcesByKey("ipRangeProfile.range"));
                rangeIP.inputIni.setAttribute("class", "textField textIPRange mandatory ipv4Start");
                rangeIP.inputFin.setAttribute("class", "textField textIPRange mandatory ipv4End");

                rangeIP.inputIni.setAttribute("name", "ipv4Start");
                rangeIP.inputFin.setAttribute("name", "ipv4End");
                rangeIP.rootEl.setAttribute('id', data[i].id);

                ipRangeValue.ini = data[i].ipv4start;
                ipRangeValue.fin = data[i].ipv4end;
                rangeIP.setValue(ipRangeValue);

                symbolPlus.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.plus"));
                symbolNegative.insertAdjacentHTML('beforeend', Monet.I18n.getResourcesByKey("ipRangeProfile.remove"));

                containerImages.appendChild(symbolNegative);
                containerImages.appendChild(symbolPlus);

                divParent.appendChild(rangeIP.rootEl);
                divParent.appendChild(containerImages);

                this.rootEl.appendChild(divParent);
                this.addRange(rangeIP);
            }

        };

        this.render = function () {
            if (data && data.length === 0) {
                this.createElement();
            } else {
                this.renderElements();
            }

            return this.rootEl;

        };
    }


    return IPRangeListFields;

}());